var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Pane'),_c('div',{staticClass:"container"},[_c('Design',{attrs:{"phaseList":_vm.list},on:{"refresh":_vm.getList}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }